module.exports = __webpack_public_path__ + "f86bf3a5934fb55249e1512fecbd36e8.pdf";